module.exports = __webpack_public_path__ + "static/media/foods.6f0f13fe.svg";